import { getModule, Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { store } from '@/iti-core-vue';
import { CategoryThirdLevel } from '@/shared/dtos/category-third-level';
import { itiTokenService } from '@/iti-core-vue/services/iti-token-service';
import { ItiString, itiHttpService } from '@/iti-core-vue';
import { API } from '@/shared/api';



@Module({
    namespaced: true,
    name: 'CategoryThirdLevelModule',
    store,
    dynamic: true,
})

class CategoryThirdLevelModule extends VuexModule implements BaseModule {
    public categories: CategoryThirdLevel[] = [];

    @Mutation
    public resetState(): void {
        this.categories = [];
    }



    @Action
    public async getCategoriesThirdLevel() {
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.get(API.categoryThirdLevel);
        this.context.commit('updateCategoriesThirdLevel', res);
    }

    @Mutation
    public updateCategoriesThirdLevel(items: CategoryThirdLevel[]) {
        this.categories = items.map(x => new CategoryThirdLevel(x));
    }

    @Action
    public async insertarCategoryThirdLevel(item: CategoryThirdLevel) {
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.post(API.categoryThirdLevel, item, false);
        this.context.dispatch('getCategoriesThirdLevel');
    }

    @Action
    public async modificarCategoryThirdLevel(item: CategoryThirdLevel) {
        if (!itiTokenService.hasToken()) { return; }
        //const apiUpdateCategory = ItiString.Format(API.categoryThirdLevelDetail, item.id);
        try {
            const res = await itiHttpService.put(API.categoryThirdLevel, item, false);
        } catch {
            // ...
        }
        this.context.dispatch('getCategoriesThirdLevel');
    }

    @Action
    public async eliminarCategoryThirdLevel(id: number) {
        if (!itiTokenService.hasToken()) { return; }
        const apiDeleteCategory = ItiString.Format(API.categoryThirdLevelDetail, id);
        const res = await itiHttpService.delete(apiDeleteCategory, id, false);
        this.context.dispatch('getCategoriesThirdLevel');
    }
}

export default getModule(CategoryThirdLevelModule);